export enum DefectSeverity {
    CRITICAL = 'Critical',
    MAJOR = 'Major',
    MINOR = 'Minor',
}